import { Injectable } from '@angular/core';
import htmlToPdfmake from 'html-to-pdfmake';
import * as pdfMake from 'pdfmake/build/pdfmake';

@Injectable()
export class CommonUtils {
    /**
     *
     */
    constructor() {
        pdfMake.fonts = {
            NotoSansCJKsc: {
                normal: 'NotoSansCJKsc-Regular.otf',
                bold: 'NotoSansCJKsc-Regular.otf',
                italics: 'NotoSansCJKsc-Regular.otf',
                bolditalics: 'NotoSansCJKsc-Regular.otf',
            },
        };
    }

    /**
     *
     * @param htmlContect HTML string content
     */
    async exportPDF(htmlContect = '') {
        const html = htmlToPdfmake(htmlContect);
        const documentDefinition = {
            content: html,
            defaultStyle: { font: 'NotoSansCJKsc' },
        };

        pdfMake.createPdf(documentDefinition).download();
    }
}
